<template>
  <el-dialog title="导出PDF" center :visible.sync="visible" width="520px" :close-on-click-modal="false" @close="close">
    <el-form label-width="30%">
      <el-form-item label="价格设置">
        <el-radio v-model="priceFlag" :label="0">带价格</el-radio>
        <el-radio v-model="priceFlag" :label="1">不带价格</el-radio>
      </el-form-item>
      <el-form-item label="实收设置">
        <el-radio v-model="realCountFlag" :label="0">带实收</el-radio>
        <el-radio v-model="realCountFlag" :label="1">不带实收</el-radio>
      </el-form-item>
      <el-form-item label="打印类型">
        <el-radio v-model="printTypeFlag" :label="0">短打印</el-radio>
        <el-radio v-model="printTypeFlag" :label="1">长打印</el-radio>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">取 消</el-button>
      <el-button size="small" @click="submitexportPdf">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  props: {
    Visible: {
      type: Boolean,
      default: false,
    },
    startEnd: {
      type: Array,
      default: null,
    },
    orderIds: {
      type: Array,
      default: () => [],
    },
    orderStatus: {
      type: Number,
      default: null,
    },
  },
  computed: {
    visible: {
      get() {
        return this.Visible;
      },
      set() { },
    },
  },
  data() {
    return {
      gysId: Number(sessionStorage.getItem('tcId')),
      priceFlag: 0,
      realCountFlag: 0,
      printTypeFlag: 0,
    };
  },
  created() {
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submitexportPdf() {
      let params;
      if (this.orderIds[0]) {
        params = {
          SERVICE_ID: '15069',
          OTYPE: 20,
          GYS_ID: this.gysId,
          ORDER_IDS: this.orderIds,
          STATUS: this.orderStatus,
          PRICE_FLAG: this.priceFlag,
          iRCOUNTFlag: this.realCountFlag,
          HALF_PAGE_FLAG: this.printTypeFlag,
        };
      } else {
        params = {
          SERVICE_ID: '15069',
          OTYPE: 19,
          GYS_ID: this.gysId,
          STATUS: this.orderStatus,
          START_DAY: this.startEnd[0],
          END_DAY: this.startEnd[1],
          PRICE_FLAG: this.priceFlag,
          iRCOUNTFlag: this.realCountFlag,
          HALF_PAGE_FLAG: this.printTypeFlag,
        };
      }
      http.post(params).then((res) => {
        window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
        this.$message.show({ text: '导出成功', type: 'success' });
        this.close();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
div>>>.el-form-item {
  /* display: flex; */
  width: 100%;
}

div>>>.el-form-item__content {
  margin-left: 30px;
  width: 70%;
}

div>>>.el-radio {
  margin-left: 10%;
}</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/purchaseOrderExportPDFForm.vue